import {RocketLaunchOutlined as AccountAppIcon} from '@mui/icons-material';
import blueGrey from '@mui/material/colors/blueGrey.js';
import React from 'react';

import AppLogo from './AppLogo.jsx';

AccountAppIcon.displayName = 'AccountAppIcon';

const AccountAppLogo = props => (
  <AppLogo icon={<AccountAppIcon />} backgroundColor={blueGrey} {...props} />
);

export default AccountAppLogo;
